// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'email-open';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path d='M10.125 9.75a3.375 3.375 0 1 1 2.25-3.18' />
    <path d='M9 7.688a1.125 1.125 0 1 0 0-2.25 1.125 1.125 0 0 0 0 2.25z' />
    <path d='M10.125 6.563a1.125 1.125 0 1 0 2.25 0' />
    <path d='M15.188 9.563V1.686A1.125 1.125 0 0 0 14.062.563H3.938a1.125 1.125 0 0 0-1.126 1.125v7.875' />
    <path d='M16.5 8.595a.578.578 0 0 1 .831.145.547.547 0 0 1 .084.297v7.275a1.125 1.125 0 0 1-1.125 1.125H1.688a1.125 1.125 0 0 1-1.125-1.125V9.037a.547.547 0 0 1 .315-.502.578.578 0 0 1 .6.06l6.135 4.425a2.25 2.25 0 0 0 2.774 0z' />
  </g>
);

export const viewBox = '0 0 18 18';
